<p class="text-center text-6xl text-primary-base py-6">
  informational-assistance works!
</p>
